import styled, { css, keyframes } from 'styled-components'

const fadeIn = keyframes`
	from {
	opacity: 0;
	}

	to {
	opacity: 1;
	}
`

const Row = styled.div`
	display: flex;
	flex-direction: row;
	margin: ${props => props.marg && props.marg};
	padding: ${props => props.pad && props.pad};
	justify-content: ${props => props.between ? 'space-between' : props.evenly ? 'space-evenly' : props.start ? 'flex-start' : 'inherit'};
	align-self: ${props => props.between ? 'space-between' : props.evenly ? 'space-evenly' : props.start ? 'flex-start' : 'inherit'};
	border-radius: ${props => props.hasRadius && props.hasRadius};
	background-color: ${props => props.bg && props.bg};
	align-items: ${props => props.center ? 'center' : (props.end ? 'flex-end' : 'flex-start')};
	border: ${props => props.border && '0.1px solid #ddd'};
	max-width: ${props => props.maxWid && props.maxWid};
	flex-wrap: ${props => props.wrapFlex ? 'wrap' : 'inherit'};
	height: ${props => props.ht || 'auto'};
	width: ${props => props.wid || 'auto'};
	gap: ${props => props.gap && props.gap};

	justify-content: inherit;
	align-self: inherit;

	${props => props.horizontalEnd && css`
		justify-content: flex-end;
		align-self: flex-end;
	`}

	${props => props.start && css`
		justify-content: flex-start;
		align-self: flex-start;
	`}

	${props => props.evenly && css`
		justify-content: space-evenly;
		align-self: unset;
	`}

	${props => props.between && css`
		justify-content: space-between;
		align-self: unset;
	`}

	${props => props.pointer && css`
		cursor: pointer;

		p {
			cursor: pointer
		}
	`};

	${props => props.hasFlex && css`flex: ${props.flex ?? 1}`};

	${props => props.pos && css`position: ${props.pos}`};

	${props => props.reverse && css`flex-direction: row-reverse`};

	${props => props.hasFade && css`animation: ${fadeIn} 0.3s linear;`}
`

export default Row
